import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import {menu} from "./showHide";
import {dropDown} from "./dropDown";
import {dark} from "./dark";

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    menu,
    dropDown,
    dark
})
export default createRootReducer